import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithSource } from '../../componentTypes';


const ReinsurerInput: InputWithSource = ({ input }) => (
    <GenericSelect label={input.name} input={input} message={ValidationMessages.requiredInput(input.name)} />
);

ReinsurerInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(ReinsurerInput);
